"use strict";

module.exports = function (column) {
  var userMultiSort = Object.keys(this.userMultiSorting);
  if (!userMultiSort.length || this.orderBy.column === column) return this.orderBy.column === column;
  return !!this.userMultiSorting[userMultiSort[0]].filter(function (col) {
    return col.column == column;
  }).length;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/currently-sorted.js
// module id = 1586
// module chunks = 64